const sidebarMenuConfig = [
  {
    title: 'Administration',
    icon: 'box',
    id: 'sidebarAdminMain',
    roles: ['admin'],
    children: [
      {
        label: 'Admin',
        id: 'sidebarAdmin',
        roles: ['admin'],
        children: [
          { label: 'List', to: '/admin/list', roles: ['admin'] },
        ],
      },
      {
        label: 'Company',
        id: 'sidebarCompany',
        roles: ['admin'],
        children: [
          { label: 'List', to: '/company/list', roles: ['admin'] },
        ],
      },
    ],
  },
  {
    title: 'Customers',
    icon: 'smartphone',
    id: 'compUI',
    roles: ['company'],
    children: [
      { label: 'List', to: '/customer/list', roles: ['company'] },
    ],
  },
  {
    title: 'Reports',
    icon: 'list',
    id: 'reportUI',
    roles: ['company'],
    children: [
      { label: 'Customer Usage', to: '/reports/customer_last_usaage', roles: ['company'] },
    ],
  },
  {
    title: 'Devices',
    icon: 'smartphone',
    id: 'customerUI',
    roles: ['customer'],
    children: [
      { label: 'Devices List', to: '/customer/device/list', roles: ['customer'] },
    ],
  },
  {
    title: 'Message',
    icon: 'message-circle',
    id: 'customerBulkUI',
    roles: ['customer'],
    children: [
      { label: 'Bulk Message', to: '/customer/bulk/message', roles: ['customer'] },
      { label: 'Batch List', to: '/customer/batch/list', roles: ['customer'] },
    ],
  },
  {
    title: 'Logs',
    icon: 'cloud-drizzle',
    id: 'customerLogsUI',
    roles: ['customer'],
    children: [
      { label: 'Logs List', to: '/customer/logs/list', roles: ['customer'] },
    ],
  },
];

export default sidebarMenuConfig;

export const filterSidebarByRole = (menuConfig, userRole) => {
  const hasAccess = (roles) => !roles || roles.includes(userRole.toLowerCase());

  const filterItems = (items) =>
    items
      .filter((item) => hasAccess(item.roles))
      .map((item) => ({
        ...item,
        children: item.children ? filterItems(item.children) : undefined,
      }))
      .filter((item) => !item.children || item.children.length > 0);

  return filterItems(menuConfig);
};